// extracted by mini-css-extract-plugin
export default {"overlay":"pv-z","bodyOpen":"qv-z","content":"rv-z","header":"sv-z","close":"tv-z","closeNoHeading":"uv-z"};